import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Box } from '@fiverr-private/theme';
import { NewBadge } from '@fiverr-private/badges';
import { useEducationTooltipContext } from '../EducationTooltipContext';

const EducationTooltipBadge = () => {
  const { variant } = useEducationTooltipContext();

  if (variant === 'white') {
    return <NewBadge />;
  }

  return (
    <Box
      as="span"
      fontSize="b_xxs"
      lineHeight="b_xxs"
      paddingY="0.5"
      paddingX="2"
      fontWeight="bold"
      borderRadius="circle"
      color="blue_700"
      backgroundColor="background"
    >
      <I18n k="education_tooltip.badgeText" />
    </Box>
  );
};

EducationTooltipBadge.displayName = 'EducationTooltipBadge';

export default EducationTooltipBadge;
